import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const museApi = createApi({
  reducerPath: "museApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "muse" }),
  endpoints: () => ({}),
  tagTypes: [
    "instruments",
    "families",
    "sections",
    "sectionInstruments",
    "sectionRoles",
  ],
});
